<template>
	<div class="text-center">
		<div v-if="temPermissaoEdicao && !isAtaAdesao && !isAtaCancelada">
			<menu-acoes
				nome-botao=""
				nome="Manuseia Ata"
				cor-de-fundo="primary"
				cor-icone="--v-anchor-base"
				icone-primary="mdi-dots-vertical"
				:acoes-menu="itens"
				@abrir-modal-exclusao-ata="abrirOuFecharModalExclusaoAta"
				@abrir-modal-gerar-ata-carona="abrirModalGerarAtaCarona"
				@abrir-modal-bloquear-ata="abrirOuFecharModalBloqueioAta"
				@abrir-modal-enviar-pncp="abrirOuFecharModalEnviarAtaPncp"
				@abrir-modal-excluir-ata-pncp="abrirOuFecharModalExcluirAtaPncp"
				@reenviar-detalhamento="reenviarDetalhamento"
				@cancelar-ata="abrirOuFecharModalCancelarAta"
			>
			</menu-acoes>

			<modal-excluir-ata
				:exibir="exibirModalExclusaoAta"
				:informacoes-ata="informacoesAta"
				@fechar-modal="abrirOuFecharModalExclusaoAta"
			></modal-excluir-ata>

			<modal-bloquear-ata
				:exibir="exibirModalBloqueioAta"
				@fechar-modal="abrirOuFecharModalBloqueioAta"
			></modal-bloquear-ata>
			<modal-enviar-ata-pncp
				:exibir="exibirModalEnviarAtaPncp"
				@fechar-modal="abrirOuFecharModalEnviarAtaPncp"
			></modal-enviar-ata-pncp>
			<modal-excluir-ata-pncp
				:exibir="exibirModalExcluirAtaPncp"
				@fechar-modal="abrirOuFecharModalExcluirAtaPncp"
			></modal-excluir-ata-pncp>
			<modal-cancelar-ata
				:exibir="exibirModalCancelarAta"
				@fechar-modal="abrirOuFecharModalCancelarAta"
			></modal-cancelar-ata>
		</div>
	</div>
</template>
<script>
import ModalExcluirAta from '@/views/pages/ata/acessar/gestao-da-ata/cabecalho/modal-excluir-ata/ModalExcluirAta.vue'
import ModalBloquearAta from '@/views/pages/ata/acessar/gestao-da-ata/cabecalho/modal-bloquear-ata/ModalBloquearAta.vue'
import validacaoAta from '@/views/mixins/validacaoAta'
import { mapState } from 'vuex'
import { actionTypes, permissoes } from '@/core/constants'
import ModalEnviarAtaPncp from '@/views/pages/ata/acessar/gestao-da-ata/cabecalho/modal-enviar-ata-pncp/ModalEnviarAtaPncp.vue'
import ModalExcluirAtaPncp from '@/views/pages/ata/acessar/gestao-da-ata/cabecalho/modal-excluir-ata-pncp/ModalExcluirAtaPncp.vue'
import ModalCancelarAta from '@/views/pages/ata/acessar/gestao-da-ata/cabecalho/modal-cancelar-ata/ModalCancelarAta.vue'

export default {
	name: 'botao-manuseia-ata',
	components: { ModalCancelarAta, ModalExcluirAtaPncp, ModalEnviarAtaPncp, ModalExcluirAta, ModalBloquearAta },
	mixins: [validacaoAta],
	data() {
		return {
			itens: [
				{
					titulo: 'Enviar PNCP',
					icone: {
						nome: 'mdi-send',
					},
					evento: 'abrir-modal-enviar-pncp',
					isVisible: () => this.estaEfetivado(this.informacoesAta),
				},
				{
					titulo: 'Cancelar PNCP',
					icone: {
						nome: 'mdi-delete',
					},
					evento: 'abrir-modal-excluir-ata-pncp',
					isVisible: () => !this.isMigracao && this.isEnviadaPncp,
				},
				{
					titulo: 'Reenviar Detalhamento',
					icone: {
						nome: 'mdi-send',
					},
					evento: 'reenviar-detalhamento',
					isVisible: () => this.isPodeReenviarDetalhamento,
					authorization: permissoes.ataIntegracaoDetalhamentoEnviar,
				},
				{
					titulo: 'Bloquear Ata',
					icone: {
						nome: 'mdi-cancel',
					},
					evento: 'abrir-modal-bloquear-ata',
					isVisible: () => this.isPodeBloquear,
					authorization: permissoes.ataBloquear,
				},
				{
					titulo: 'Desbloquear Ata',
					icone: {
						nome: 'mdi-cancel',
					},
					evento: 'abrir-modal-bloquear-ata',
					isVisible: () => this.isPodeDesbloquear,
					authorization: permissoes.ataDesbloquear,
				},
				{
					titulo: 'Excluir',
					icone: {
						nome: 'mdi-delete',
					},
					evento: 'abrir-modal-exclusao-ata',
					authorization: permissoes.ataExcluir,
				},
				{
					titulo: 'Cancelar Ata',
					icone: {
						nome: 'mdi-close-circle-outline',
					},
					evento: 'cancelar-ata',
					authorization: permissoes.ataCancelar,
					isVisible: () => this.isPodeCancelar,
				},
			],
			exibirModalExclusaoAta: false,
			exibirModalBloqueioAta: false,
			exibirModalEnviarAtaPncp: false,
			exibirModalExcluirAtaPncp: false,
			exibirModalCancelarAta: false,
		}
	},
	computed: {
		...mapState({
			informacoesAta: (state) => state.ata.informacoesAta,
			isIntegracaoTceAtivo: (state) => state.parametrosSistema.isIntegracaoTceAtivo,
		}),
		isPodeBloquear() {
			return this.informacoesAta && !this.informacoesAta.isBloqueado && this.naoExisteAcaoSeAtaEstiverEfetivada
		},
		isPodeDesbloquear() {
			return this.informacoesAta && this.informacoesAta.isBloqueado && this.estaEfetivado(this.informacoesAta)
		},
		naoExisteAcaoSeAtaEstiverEfetivada() {
			return this.informacoesAta && this.estaEfetivado(this.informacoesAta)
		},
		isEnviadaPncp() {
			return this.informacoesAta && this.estaEnviadaPncp(this.informacoesAta)
		},
		isPodeReenviarDetalhamento() {
			return (
				this.isIntegracaoTceAtivo &&
				!this.informacoesAta?.isEnviadoDetalhamento &&
				this.estaEfetivado(this.informacoesAta)
			)
		},
		isAtaCancelada() {
			return this.estaCancelada(this.informacoesAta.situacao)
		},
		isPodeCancelar() {
			return (
				(this.estaEmElaboracao(this.informacoesAta) || this.estaEfetivado(this.informacoesAta)) &&
				this.temPermissaoEdicao
			)
		},
	},
	methods: {
		abrirOuFecharModalExclusaoAta() {
			this.exibirModalExclusaoAta = !this.exibirModalExclusaoAta
		},
		abrirOuFecharModalBloqueioAta() {
			this.exibirModalBloqueioAta = !this.exibirModalBloqueioAta
		},
		abrirModalGerarAtaCarona() {
			alert('Não possui funcionalidade')
		},
		abrirOuFecharModalEnviarAtaPncp() {
			this.exibirModalEnviarAtaPncp = !this.exibirModalEnviarAtaPncp
		},
		abrirOuFecharModalExcluirAtaPncp() {
			this.exibirModalExcluirAtaPncp = !this.exibirModalExcluirAtaPncp
		},
		abrirOuFecharModalCancelarAta() {
			this.exibirModalCancelarAta = !this.exibirModalCancelarAta
		},
		async reenviarDetalhamento() {
			await this.$store
				.dispatch(actionTypes.ATA.REENVIAR_ATA_PARA_DETALHAMENTO, this.informacoesAta.id)
				.then(() => {
					this.informacoesAta['isEnviadoDetalhamento'] = true
					this.mostrarNotificacaoSucessoDefault()
				})
		},
	},
}
</script>

<style scoped lang="stylus">
.botao-manuseia-ata-disabled
	cursor not-allowed

	> .v-btn
		background-color transparent

	.theme--light.v-btn.v-btn--disabled, .theme--light.v-btn.v-btn--disabled .v-btn__loading, .theme--light.v-btn.v-btn--disabled .v-icon
		color #ababab !important
</style>
